<template>
	<app-content class="h-panel">
		<div class="h-panel-bar"><span class="h-panel-title">账套模板</span></div>
		<div class="margin-top margin-left margin-right">
			<div style="display: flex;">
				<input type="text" v-model="name" placeholder="输入模板名称搜索" style="width: 240px;"
					   @keyup.enter="doSearch"/>
				<Button color="primary" :loading="loading" @click="doSearch">搜索</Button>
				<Button color="primary" style="margin-left: auto;" icon="fa fa-plus" @click="openForm()">新增模板</Button>
			</div>
		</div>
		<div class="h-panel-body">
			<Table :datas="dataList" :loading="loading">
				<TableItem prop="id" title="ID" :width="70"/>
				<TableItem prop="name" title="模板名称"/>
				<TableItem prop="industry" title="适用行业" :width="120"/>
				<TableItem prop="accountingStandards" title="会计准则" :width="140"/>
				<TableItem prop="vatType" title="增值税类型" :width="110"/>
				<TableItem prop="description" title="描述"/>
				<TableItem title="创建时间" :width="150">
					<template slot-scope="{data}">
						{{ datetimeFormat(data.createDate) }}
					</template>
				</TableItem>
				<TableItem title="操作" :width="120" align="center">
					<div class="actions" slot-scope="{data}">
						<span @click="openForm(data)">编辑</span>
						<span @click="remove(data)">删除</span>
					</div>
				</TableItem>
			</Table>
			<Pagination style="margin-top: 10px;" v-model="pagination" layout="total,sizes,pager,jumper"
						@change="loadList" small align="right"/>
		</div>

		<Modal v-model="showForm" hasCloseIcon hasDivider :closeOnMask="false">
			<div slot="header">{{ form.id ? '编辑模板' : '新增模板' }}</div>
			<Form :labelWidth="90" ref="form" :rules="validationRules" :model="form">
				<FormItem label="模板名称" prop="name">
					<input type="text" v-model="form.name" maxlength="128" placeholder="例如：小规模纳税人模板"/>
				</FormItem>
				<FormItem label="适用行业" prop="industry">
					<input type="text" v-model="form.industry" maxlength="64" placeholder="例如：商贸零售"/>
				</FormItem>
				<FormItem label="会计准则" prop="accountingStandards">
					<input type="text" v-model="form.accountingStandards" maxlength="64" placeholder="例如：小企业会计准则"/>
				</FormItem>
				<FormItem label="增值税类型" prop="vatType">
					<input type="text" v-model="form.vatType" maxlength="64" placeholder="例如：小规模纳税人"/>
				</FormItem>
				<FormItem label="模板描述" prop="description">
					<textarea v-model="form.description" rows="3" maxlength="500" placeholder="模板用途说明"></textarea>
				</FormItem>
			</Form>
			<div slot="footer">
				<Button @click="showForm=false">取消</Button>
				<Button color="primary" :loading="saving" @click="save">保存</Button>
			</div>
		</Modal>
	</app-content>
</template>

<script>
	import moment from 'moment';

	export default {
		name: "AdminAccountTemplates",
		data() {
			return {
				loading: false,
				saving: false,
				showForm: false,
				name: '',
				dataList: [],
				pagination: {page: 1, size: 20, total: 0},
				form: {},
				validationRules: {
					required: ['name']
				}
			}
		},
		methods: {
			loadList() {
				this.loading = true;
				this.$api.admin.templates({
					page: this.pagination.page,
					size: this.pagination.size,
					name: this.name || undefined
				}).then(({data}) => {
					this.dataList = data.records || [];
					this.pagination.total = Number(data.total || 0);
				}).finally(() => this.loading = false);
			},
			doSearch() {
				this.pagination.page = 1;
				this.loadList();
			},
			openForm(data) {
				this.form = data ? Object.assign({}, data) : {name: '', industry: '', accountingStandards: '', vatType: '', description: ''};
				this.showForm = true;
			},
			save() {
				if (!this.$refs.form.valid().result) {
					return;
				}
				this.saving = true;
				let request = this.form.id
					? this.$api.admin.updateTemplate(this.form)
					: this.$api.admin.addTemplate(this.form);
				request.then(() => {
					this.$Message.success('保存成功~');
					this.showForm = false;
					this.loadList();
				}).finally(() => this.saving = false);
			},
			remove(data) {
				this.$Confirm(`确认删除模板【${data.name}】?`).then(() => {
					this.$api.admin.deleteTemplate({id: data.id}).then(() => {
						this.$Message.success('删除成功~');
						this.loadList();
					});
				});
			},
			datetimeFormat(date) {
				return date ? moment(date).format('YYYY-MM-DD HH:mm') : '';
			}
		},
		mounted() {
			this.loadList();
		}
	}
</script>
